import i18n from 'i18next';

export const badReq = () => {
    alert(i18n.t('ErrorBody'));
};

export const noConnection = () => {
    alert(i18n.t('ErrorConn'));
};
